/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  MailboxChannelResponse
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * This user's mailbox, or nothing. Never another user's.
 * @summary Get My Mailbox Channel
 */
export const getMyMailboxChannel = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<MailboxChannelResponse>(
      {url: `/mailbox/channel`, method: 'GET', signal
    },
      options);
    }




export const getGetMyMailboxChannelQueryKey = () => {
    return [
    `/mailbox/channel`
    ] as const;
    }


export const getGetMyMailboxChannelQueryOptions = <TData = Awaited<ReturnType<typeof getMyMailboxChannel>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyMailboxChannel>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyMailboxChannelQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyMailboxChannel>>> = ({ signal }) => getMyMailboxChannel(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyMailboxChannel>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyMailboxChannelQueryResult = NonNullable<Awaited<ReturnType<typeof getMyMailboxChannel>>>
export type GetMyMailboxChannelQueryError = unknown


/**
 * @summary Get My Mailbox Channel
 */

export function useGetMyMailboxChannel<TData = Awaited<ReturnType<typeof getMyMailboxChannel>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyMailboxChannel>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyMailboxChannelQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Stop syncing, and forget the credential.
 *
 * THE MAIL ALREADY FILED STAYS. Deleting the channel cascades its
 * associations and nothing else: a message filed against a client is the
 * firm's record of that relationship, and an advisor leaving must not tear a
 * hole in it. What goes is the grant and this mailbox's claim to have seen
 * them.
 *
 * THE GRANT IS REVOKED AT GOOGLE ONLY WHEN NOTHING ELSE NEEDS IT. Without
 * `GOOGLE_MAIL_CLIENT_ID` the mailbox's token comes from the calendar's
 * Google client, and revoking one token revokes the whole grant, calendar
 * scopes included. So a Gmail mailbox is revoked only when this user holds
 * no Google calendar on the same client and account; otherwise only our
 * copy goes. See `v1/google_grant.py`.
 * @summary Disconnect My Mailbox
 */
export const disconnectMyMailbox = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<MailboxChannelResponse>(
      {url: `/mailbox/channel`, method: 'DELETE', signal
    },
      options);
    }




export const getDisconnectMyMailboxMutationKey = () => ['disconnectMyMailbox'] as const;

export const getDisconnectMyMailboxMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectMyMailbox>>, TError,void, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectMyMailbox>>, TError,void, TContext> => {

const mutationKey = getDisconnectMyMailboxMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectMyMailbox>>, void> = () => {


          return  disconnectMyMailbox(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectMyMailboxMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectMyMailbox>>>

    export type DisconnectMyMailboxMutationError = unknown


    /**
 * @summary Disconnect My Mailbox
 */
export const useDisconnectMyMailbox = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectMyMailbox>>, TError,void, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectMyMailbox>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectMyMailboxMutationOptions(options));
    }
